import { createVanIconComponent } from "./van"

const Comment = createVanIconComponent("comment")
export default Comment
